<app-organizer-shared-layout-edit-field
  [title]="translateKey('.title')"
  [description]="translateKey('.description')"
  [isFormValid]="isFormValid"
  [isFormDirty]="equipmentsForm.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateEquipment()"
>
  <div [formGroup]="equipmentsForm" class="form-group">
    <p class="mb-3 body-bold">
      {{ 'organizer.edit.equipment.list.label' | translate }}
    </p>

    <ng-container
      *ngFor="let equipment of equipments.controls; let equipmentIndex = index"
    >
      <app-form-input-group
        [label]="'a11y.organizer.edit.equipment.list.label' | translate"
        [isHiddenLabel]="true"
      >
        <app-form-input
          #content
          class="block mb-3"
          [formControl]="equipment"
          [rightButtonAriaLabel]="
            translateKey('.delete-button', { name: equipment })
          "
          [rightButtonIconType]="crossIconType"
          [placeholder]="translateKey('.form.input.placeholder')"
          (rightButtonClick)="deleteEquipment(equipmentIndex)"
          #equipmentInputs
        ></app-form-input>
      </app-form-input-group>
    </ng-container>
  </div>
  <button
    app-vtmn-play-button
    type="button"
    app-cta
    [type]="ctaButtonType.Button"
    [variant]="vtmnPlayButtonVariant.SECONDARY"
    (click)="addEquipment()"
  >
    {{ translateKey('.add-button') }}
  </button>
</app-organizer-shared-layout-edit-field>
